import { useSociete, useSocieteService } from '@europrocurement/l2d-domain';
import { SocieteJsonldSocieteReadItem } from '@europrocurement/l2d-domain/openApi/ApiSociete';

const useSocieteInfo = () => {
    const { societeApi } = useSocieteService();
    const xIdSociete = useSociete();

    const getSocieteData = (): Promise<SocieteJsonldSocieteReadItem> =>
        new Promise((resolve, reject) => {
            const requestParameter = {
                id: xIdSociete as unknown as string,
                xIdSociete,
            };

            societeApi
                .getSocieteSocieteItem(requestParameter)
                .then((response) => {
                    const societeData = response.data ?? null;

                    if (societeData) {
                        resolve(societeData as SocieteJsonldSocieteReadItem);

                        return;
                    }

                    reject();
                })
                .catch(() => reject());
        });

    return { getSocieteData };
};

export default useSocieteInfo;
